import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import LandingPage from './pages/LandingPage';

// A component that manages the Router and animations
const AppContent = () => {
  const location = useLocation();
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Box component="main" flexGrow={1} mt={8}>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
          <Route path="/" element={<LandingPage />} />
          </Routes>
        </AnimatePresence>
      </Box>
    </Box>
  );
};

// main app
function App() {
  useEffect(() => {
    // Dynamically inject Microsoft Clarity script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "s9jkinye78");
    `;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Router>
          <CssBaseline />
          <AppContent />
    </Router>
  );
}

export default App;
